/*!
 * @Author: jinbin
 * @Date: 2020-02-07 19:21:00
 * @Last Modified by: jinbin
 * @Last Modified time: 2020-02-07 19:21:00
 * @Instruduction: 帮助中心服务接口
 */

import xhr from './xhr/index'

interface IBugListParams {
    type?: number         // 类型
    status?: number       // 状态
    news_id?: number
    page_index?: number    // 第几页
    page_size?: number     // 每页条数
}

interface IUpdateBugParams {
    id: number   // bug ID
    memo?: string,
    status?: number
}

interface IAddBugParams {
    news_id: number   // 新闻 ID
    data: object[]    // bug 类型以及备注信息
}

class HelpService {
    /** 获取文章分类  */
    public getArticleTypes(params: any) {
        return xhr({
            method: 'get',
            url: '/help/article/types',
            params
        })
    }

    /** 创建文章分类  */
    public createArticleType(params: any) {
        return xhr({
            method: 'post',
            url: '/help/article/type',
            params
        })
    }

    /** 修改文章分类  */
    public updateArticleType(params: any) {
        return xhr({
            method: 'put',
            url: '/help/article/type',
            params
        })
    }

    /** 删除文章分类  */
    public deleteArticleType(params: any) {
        return xhr({
            method: 'delete',
            url: '/help/article/type',
            params
        })
    }

    /** 文章列表 */
    public getArticles(params: any) {
        return xhr({
            method: 'get',
            url: '/help/articles',
            params
        })
    }

    /** 文章详情 */
    public getArticleDetail(params: any) {
        return xhr({
            method: 'get',
            url: '/help/article',
            params
        })
    }

    /** 创建文章 */
    public createArticle(params: any) {
        return xhr({
            method: 'post',
            url: '/help/article',
            params
        })
    }

    /** 修改文章 */
    public updateArticle(params: any) {
        return xhr({
            method: 'put',
            url: '/help/article',
            params
        })
    }

    /** 删除文章 */
    public deleteArticle(params: any) {
        return xhr({
            method: 'delete',
            url: '/help/article',
            params
        })
    }
}

// 实例化后导出，全局单例
export default new HelpService()
